const breakpoints = { drawerWidth: 250, toolbarHeight: 64 };

export default breakpoints;
